import { EditorMarkdown, EditorMarkdownProps } from '../../EditorMarkdown';
import { FormFieldProps } from '../types';
import { splitProps } from '@/utils';
import { Field, useField } from '../Field';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

export const EditorMarkdownComponent = (props: EditorMarkdownProps) => {
  const field = useField();
  const { setValue } = useFormContext();

  const handleChange = useCallback(
    (value: string) => {
      setValue(field.name, value, { shouldDirty: true, shouldValidate: true });
    },
    [setValue, field.name],
  );

  return <EditorMarkdown {...{ ...props, ...field, onChange: handleChange }} />;
};

export const EditorMarkdownField = (fieldProps: FormFieldProps<EditorMarkdownProps>) => {
  const restProps = splitProps(fieldProps, [
    'className',
    'disabled',
    'onImageSave',
  ]) as EditorMarkdownProps;

  return (
    <Field {...{ ...fieldProps, nonTouchedError: true }}>
      <EditorMarkdownComponent {...restProps} />
    </Field>
  );
};
